<template>
</template>

<script>
import axios from 'axios';
  
  export default {
    props: {
      isUserLoggedIn: {
        type: Boolean, 
        default: false
      },
      userDataUrl: {
        type: String,
        default: '/umbraco/surface/authenticationapi/currentprofile'
      },
      pageData: {
        type: String,
        default: ''
      },
      tourData: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        userData: null
      };
    },
    mounted: async function() {
      if(this.isUserLoggedIn){
        await this.fetchUserData(this.userDataUrl);
      }
      GTM.pageViewEvent(this.pageData, this.userData);
      if(this.tourData !== ''){
        const tourData = JSON.parse(this.tourData);
        GTM.viewItem(tourData);
      }
    },
    methods: {
      async fetchUserData(url) {
        try {
          const response = await axios.get(url);
          this.userData = response.data;
        } catch (error) {}
      }
    },
  };
</script>
